module.exports = {"DELIVERY_RANGES":"results","DELIVERY_RANGE":{"LOWER":"lower","UPPER":"upper"}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/kapida/platformConfigs/integrationMaps/packageDeliveryRanges.json
// module id = 1780
// module chunks = 1